<template>

    <div class="timepicker d-flex">
        <v-select class="w-95 mr-5" :model="params.hour" :size="size" @input="params.hour = $event">
            <option v-for="h in hours" :key="h" :value="h">{{ h }}</option>
        </v-select>
        <v-select class="w-95 mr-5" :model="params.minute" :size="size" @input="params.minute = $event">
            <option v-for="m in minutes" :key="m" :value="m">{{ m }}</option>
        </v-select>
        <v-select class="w-100" :model="params.ampm" :size="size" @input="params.ampm = $event">
            <option value="AM">AM</option>
            <option value="PM">PM</option>
        </v-select>
    </div>

</template>

<script>

import moment from 'moment';

export default {

    props: {
        model: {
            required: true,
        },
        size: {
            type: String,
            default: 'md',
        },
    },

    data() {
        return {
            params: {
                hour: '',
                minute: '',
                ampm: '',
            },
        }
    },

    computed: {

        hours() {
            let hours = [];
            for (let i = 1; i <= 12; i++) {
                hours.push(i < 10 ? `0${i}` : i);
            }
            return hours;
        },

        minutes() {
            let minutes = [];
            for (let i = 0; i <= 59; i += 5) {
                minutes.push(i < 10 ? `0${i}` : i);
            }
            return minutes;
        },

        timeString() {
            let time = `${this.params.hour}:${this.params.minute} ${this.params.ampm}`;
            return moment(time, 'hh:mm A').format('HH:mm');
        },

    },

    created() {
        this.parseTime(this.model || '12:00');
    },

    watch: {

        params: {
            deep: true,
            handler(val) {
                this.$emit('input', this.timeString);
            }
        },

    },

    methods: {

        parseTime(str) {
            let time = moment(str, 'HH:mm');
            this.params.hour = time.format('hh');
            this.params.minute = time.format('mm');
            this.params.ampm = time.format('A');
        },

    },

}

</script>
